import { render, staticRenderFns } from "./SpecialTerms.vue?vue&type=template&id=1073bc26"
import script from "./SpecialTerms.vue?vue&type=script&lang=js"
export * from "./SpecialTerms.vue?vue&type=script&lang=js"
import style0 from "./SpecialTerms.vue?vue&type=style&index=0&id=1073bc26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports